import React from 'react'

// form fields
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'

// components
import WeightAndDimensions from './includes/WeightAndDimensions'
import ShippingRates from './includes/ShippingRates'
import Taxes from './includes/Taxes'

export default function TaxAndShippingTab(props) {
    // props
    const {
        formik
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    <div className="d-flex align-items-center mb-2">
                        {/* heading */}
                        <p className="box-heading st-fs-18 st-fw-600 st-text-color me-3">This Product requires Shipping or Pickup</p>
                        {/* form field */}
                        <AppFormikRadio
                            formik={formik} // formik object
                            labelClass={"align-items-center mb-0"} // class name for main wrapper
                            checkedText={"Enabled"} // name when the radio is checked
                            unCheckedText={"Disabled"} // name when the radio is checked
                            // isRequired={true} // is this field is required or not to show the red star sign
                            formikFieldName={"isFeatured"} // important: formik value name for the input
                        />
                    </div>
                    <p className="st-fs-13 st-text-color2">
                        Enable this option if the product needs to be physically delivered to customer either via shipping or by self-pickup.
                        If this product is a service or a downloadable item that doesn't require delivey, keep this option disabled.
                    </p>
                </div>
            </div>

            {/* weight and dimensions */}
            <WeightAndDimensions formik={formik} />

            {/* shipping rates */}
            <ShippingRates formik={formik} />

            {/* shipping rates */}
            <Taxes formik={formik} />


        </React.Fragment>
    )
}
